import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  ta: {
    translation: {
      // App & Navigation
      appTitle: 'கவிதைகள்',
      appSubtitle: 'தமிழ் கவிதைகளின் நவீன தளம்',
      nav: {
        home: 'முகப்பு',
        poems: 'கவிதைகள்',
        admin: 'நிர்வாகம்',
        myArea: 'எனது பகுதி',
        login: 'உள் நுழை',
        logout: 'வெளியேறு',
        register: 'பதிவு செய்',
        forgotPassword: 'கடவுச்சொல் மறந்துவிட்டது',
        about: 'பற்றி',
        contact: 'தொடர்பு',
        openMenu: 'வழிசெலுத்தல் பட்டியைத் திறக்க',
        closeMenu: 'வழிசெலுத்தல் பட்டியை மூட',
        languageMenuLabel: 'மொழியை மாற்று',
        switchToDarkMode: 'டார்க் முறைக்கு மாற்று',
        switchToLightMode: 'லைட் முறைக்கு மாற்று',
      },

      // Admin Panel
      adminPanel: {
        title: 'நிர்வாக பேனல்',
        description: 'நிர்வாகி செயல்பாடுகள்',
        subtitle: 'சிறப்பு நிர்வாகி செயல்பாடுகள்',
        placeholder: 'இந்த பகுதி இன்னும் வளர்ச்சியில் உள்ளது. பின்னர் சிறப்பு நிர்வாகி செயல்பாடுகள் கிடைக்கும்.',
        comingSoon: 'செயல்பாடுகள் விரைவில் வரும்...',
        pendingRegistrations: 'நிலுவையில் உள்ள பதிவுகள்',
        noPendingUsers: 'நிலுவையில் உள்ள பதிவுகள் இல்லை',
        username: 'பயனர்பெயர்',
        email: 'மின்னஞ்சல்',
        name: 'பெயர்',
        registered: 'பதிவு செய்யப்பட்ட தேதி',
        actions: 'செயல்கள்',
        approve: 'அனுமதி',
        reject: 'நிராகரி',
        rejectConfirmTitle: 'பதிவை நிராகரிக்கவா?',
        rejectConfirmText: 'இந்த பதிவை உண்மையில் நிராகரிக்க விரும்புகிறீர்களா? பயனர் நீக்கப்படுவார் மற்றும் உள்நுழைய முடியாது.',
        cancel: 'ரத்துசெய்',
        confirmReject: 'நிராகரி',
        approveError: 'பயனரை அனுமதிப்பதில் பிழை',
        rejectError: 'பயனரை நிராகரிப்பதில் பிழை',
        refresh: 'புதுப்பிக்க',
      },

      // Admin
      admin: {
        dashboard: 'நிர்வாக கட்டுப்பாட்டு பலகை',
        welcome: 'மீண்டும் வரவேற்கிறோம்',
        totalPoems: 'மொத்த கவிதைகள்',
        publishedPoems: 'வெளியிடப்பட்டவை',
        draftPoems: 'வரைவுகள்',
        views: 'பார்வைகள்',
        quickActions: 'விரைவு செயல்கள்',
        createPoem: 'புதிய கவிதை உருவாக்கு',
        viewSite: 'தளத்தைப் பார்',
        recentPoems: 'சமீபத்திய கவிதைகள்',
        edit: 'திருத்து',
        delete: 'நீக்கு',
        deleteConfirmation: 'இந்த கவிதையை நீக்க விரும்புகிறீர்களா?',
      },

      // Manage Poems
      managePoems: {
        managePoems: 'கவிதைகளை நிர்வகி',
        createNew: 'புதிய கவிதை உருவாக்கு',
        totalPoems: 'மொத்த கவிதைகள்',
        published: 'வெளியிடப்பட்டவை',
        drafts: 'வரைவுகள்',
        searchPlaceholder: 'கவிதைகளைத் தேடு...',
        filter: 'வடிகட்டு',
        all: 'அனைத்தும்',
        title: 'தலைப்பு',
        author: 'கவிஞர்',
        status: 'நிலை',
        views: 'பார்வைகள்',
        tags: 'குறிச்சொற்கள்',
        updated: 'புதுப்பிக்கப்பட்டது',
        actions: 'செயல்கள்',
        view: 'பார்',
        edit: 'திருத்து',
        delete: 'நீக்கு',
        noPoemsFound: 'கவிதைகள் எதுவும் கிடைக்கவில்லை',
        tryDifferentSearch:
          'உங்கள் தேடல் அல்லது வடிகட்டல் அளவுகோல்களை சரிசெய்ய முயற்சிக்கவும்',
        createFirstPoem: 'தொடங்க உங்கள் முதல் கவிதையை உருவாக்கவும்',
        deletePoem: 'கவிதையை நீக்கு',
        deleteWarning: 'இந்த செயலை மீளமுடியாது.',
        deleteConfirm: 'நீங்கள் நிச்சயமாக நீக்க விரும்புகிறீர்களா',
        cancel: 'ரத்து செய்',
      },

      // Logout
      logout: {
        successTitle: 'வெற்றிகரமாக வெளியேறியது',
        successMessage:
          'உங்கள் கணக்கிலிருந்து வெற்றிகரமாக வெளியேறியுள்ளீர்கள். உங்கள் அனைத்து அமர்வு தரவுகளும் பாதுகாப்பாக நீக்கப்பட்டன.',
        securityNote:
          'பாதுகாப்பு காரணங்களுக்காக, நீங்கள் பொது கணினியில் வேலை செய்கிறீர்கள் என்றால் உங்கள் உலாவியை மூடுமாறு பரிந்துரைக்கிறோம்.',
        backToHome: 'முகப்புக்கு திரும்பு',
        loginAgain: 'மீண்டும் உள்நுழைய',
        thankYou: 'Kavithai.de ஐப் பயன்படுத்தியதற்கு நன்றி',
      },

      // 404 Not Found
      notFound: {
        title: 'பக்கம் கிடைக்கவில்லை',
        message:
          'நீங்கள் தேடும் பக்கம் இல்லை அல்லது நகர்த்தப்பட்டது. URL ஐ சரிபார்க்கவும் அல்லது முகப்பு பக்கத்திற்குத் திரும்பவும்.',
        suggestion:
          'நீங்கள் URL ஐ தவறாக தட்டச்சு செய்திருக்கலாம் அல்லது பக்கம் மறுபெயரிடப்பட்டிருக்கலாம்.',
        backToHome: 'முகப்புக்கு திரும்பு',
        goBack: 'திரும்பு',
        browsePoems: 'கவிதைகளை உலாவு',
        contact: 'தொடர்பு',
        helpText:
          'உதவி தேவையா? தொடர்பு பக்கத்தின் மூலம் எங்களைத் தொடர்பு கொள்ளுங்கள்.',
      },

      // Poems (legacy)
      addPoem: 'புதிய கவிதை',
      editPoem: 'கவிதையைத் திருத்து',
      deletePoem: 'கவிதையை நீக்கு',
      poemTitle: 'கவிதை தலைப்பு',
      poemAuthor: 'கவிஞர்',
      poemDate: 'தேதி',
      poemContent: 'கவிதை உள்ளடக்கம்',
      poemLanguage: 'மொழி',
      poemCategory: 'வகை',
      poemTags: 'குறிச்சொற்கள்',

      // Form Fields
      title: 'தலைப்பு',
      author: 'ஆசிரியர்',
      language: 'மொழி',
      content: 'உள்ளடக்கம்',
      category: 'வகை',
      tags: 'குறிச்சொற்கள்',
      published: 'வெளியிடப்பட்டது',
      draft: 'வரைவு',

      // Actions
      save: 'சேமிக்க',
      cancel: 'ரத்து செய்',
      edit: 'திருத்து',
      delete: 'நீக்கு',
      publish: 'வெளியிடு',
      unpublish: 'வெளியீட்டை நிறுத்து',
      search: 'தேடு',
      filter: 'வடிகட்டி',
      sort: 'வரிசைப்படுத்து',
      copy: 'நகலெடு',
      share: 'பகிர்',
      like: 'விரும்பு',
      bookmark: 'புத்தகக்குறி',

      // Authentication
      email: 'மின்னஞ்சல்',
      password: 'கடவுச்சொல்',
      signIn: 'உள் நுழை',
      signOut: 'வெளியேறு',
      loginSuccess: 'வெற்றிகரமாக உள் நுழைந்தீர்கள்',
      loginError: 'உள் நுழைவில் பிழை',

      // UI Elements
      loading: 'ஏற்றுகிறது...',
      error: 'பிழை',
      technicalError:
        'தொழில்நுட்பப் பிழை. தயவுசெய்து பிறகு மீண்டும் முயற்சிக்கவும்.',
      success: 'வெற்றி',
      warning: 'எச்சரிக்கை',
      info: 'தகவல்',
      close: 'மூடு',
      retry: 'மீண்டும் முயற்சிக்கவும்',
      back: 'திரும்பு',
      next: 'அடுத்து',
      previous: 'முந்தைய',
      readMore: 'மேலும் படிக்க',
      showLess: 'குறைவாக காட்டு',
      by: 'எழுதியவர்',

      // Toast Messages
      poemNotFound: 'கவிதை கிடைக்கவில்லை',
      poem: {
        notFoundTitle: 'கவிதை கிடைக்கவில்லை',
        notFoundMessage: 'இந்தக் கவிதை நீக்கப்பட்டிருக்கலாம் அல்லது கிடைக்கவில்லை.',
        errorTitle: 'தொழில்நுட்பப் பிழை',
        errorMessage:
          'ஒரு தொழில்நுட்பப் பிழை ஏற்பட்டுள்ளது. தயவுசெய்து பிறகு முயற்சிக்கவும்.',
        views: 'பார்வைகள்',
      },

      // Contact Form
      contact: {
        title: 'தொடர்பு கொள்ளுங்கள்',
        subtitle:
          'உங்களுக்கு ஏதேனும் கேள்வி அல்லது பரிந்துரை உள்ளதா? உங்களிடமிருந்து கேட்க விரும்புகிறோம். எங்களுக்கு ஒரு செய்தி அனுப்புங்கள், விரைவில் பதிலளிப்போம்.',
        description:
          'Kavithai.de உடன் தொடர்பு கொள்ளுங்கள். உங்களிடமிருந்து கேட்க விரும்புகிறோம்!',
        form: {
          title: 'எங்களுக்கு ஒரு செய்தி அனுப்புங்கள்',
          name: 'பெயர்',
          namePlaceholder: 'உங்கள் முழு பெயர்',
          nameRequired: 'பெயர் தேவை',
          nameMinLength: 'பெயர் குறைந்தது 2 எழுத்துக்களாக இருக்க வேண்டும்',
          email: 'மின்னஞ்சல்',
          emailPlaceholder: 'உங்கள்.மின்னஞ்சல்@உதாரணம்.com',
          emailRequired: 'மின்னஞ்சல் தேவை',
          emailInvalid: 'தவறான மின்னஞ்சல் முகவரி',
          subject: 'பொருள்',
          subjectPlaceholder: 'இது எதைப் பற்றியது?',
          subjectRequired: 'பொருள் தேவை',
          subjectMinLength: 'பொருள் குறைந்தது 5 எழுத்துக்களாக இருக்க வேண்டும்',
          message: 'செய்தி',
          messagePlaceholder: 'உங்கள் செய்தி இங்கே...',
          messageRequired: 'செய்தி தேவை',
          messageMinLength: 'செய்தி குறைந்தது 10 எழுத்துக்களாக இருக்க வேண்டும்',
          send: 'செய்தி அனுப்பு',
          sending: 'அனுப்புகிறது...',
          success:
            'உங்கள் செய்திக்கு நன்றி! விரைவில் உங்களைத் தொடர்புகொள்வோம்.',
          error: 'செய்தி அனுப்புதல் தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும்.',
        },
        info: {
          title: 'தொடர்பு தகவல்',
          email: 'மின்னஞ்சல்',
          phone: 'தொலைபேசி',
          phoneAvailable: 'கோரிக்கையின் பேரில் கிடைக்கும்',
          location: 'இடம்',
        },
        help: {
          title: 'உதவி தேவையா?',
          description:
            'எங்கள் FAQ ஐப் பார்க்கவும் அல்லது எங்கள் கவிதைத் தொகுப்பை உலாவவும்.',
          exploreButton: 'கவிதைகளை ஆராயுங்கள்',
        },
      },

      // Accessibility
      fontSize: 'எழுத்து அளவு',
      increaseFont: 'எழுத்து அளவை அதிகரிக்க',
      decreaseFont: 'எழுத்து அளவை குறைக்க',
      highContrast: 'உயர் ஒளிர்வு',
      skipToContent: 'உள்ளடக்கத்திற்குச் செல்',
      accessibilityMenuOpen: 'அணுகல் கட்டுப்பாடுகளைத் திறக்க',
      accessibilityMenuClose: 'அணுகல் கட்டுப்பாடுகளை மூட',
      fontSizeSliderLabel: 'அடிப்படை எழுத்து அளவை மாற்று',
      highContrastToggleLabel: 'உயர் ஒளிர்வு நிலையை மாற்று',

      // Messages
      noPoemsFound: 'கவிதைகள் எதுவும் கிடைக்கவில்லை',
      confirmDelete: 'இந்த கவிதையை நீக்க விரும்புகிறீர்களா?',
      poemSaved: 'கவிதை வெற்றிகரமாக சேமிக்கப்பட்டது',
      poemDeleted: 'கவிதை நீக்கப்பட்டது',
      shareCopied: 'இணைப்பு நகலெடுக்கப்பட்டது',
      shareSuccess: 'கவிதை பகிரப்பட்டது',
      shareError: 'பகிர்வதில் பிழை',
      adminLoginDescription:
        'கவிதைகளை நிர்வகிக்க நிர்வாக கணக்கில் உள்நுழையவும்.',
      forgotPassword: {
        title: 'கடவுச்சொல் மறந்துவிட்டது',
        description: 'உங்கள் கடவுச்சொல்லை மீட்டமைக்க ஒரு இணைப்பைப் பெற உங்கள் மின்னஞ்சல் முகவரி அல்லது பயனர்பெயரை உள்ளிடவும்.',
        emailLabel: 'மின்னஞ்சல் முகவரி',
        usernameLabel: 'பயனர்பெயர்',
        or: 'அல்லது',
        sendResetLink: 'மீட்டமைப்பு இணைப்பை அனுப்பு',
        sending: 'அனுப்புகிறது...',
        successMessage: 'இந்த மின்னஞ்சல் முகவரி அல்லது பயனர்பெயருடன் கணக்கு இருந்தால், கடவுச்சொல் மீட்டமைப்பு இணைப்பு அனுப்பப்பட்டது. தயவுசெய்து உங்கள் மின்னஞ்சல் பெட்டியை சரிபார்க்கவும்.',
        backToHome: 'முகப்புக்கு திரும்பு',
        error: 'கடவுச்சொல் மீட்டமைப்பு இணைப்பை அனுப்புவதில் பிழை. மீண்டும் முயற்சிக்கவும்.',
      },
      loginForm: {
        headline: 'உள்நுழைவு',
        intro:
          'அடுத்த படியில் நீங்கள் பாதுகாப்பான Keycloak உள்நுழைவு பக்கத்திற்கு மாற்றப்படுவீர்கள்.',
        error: 'உள்நுழைவு தோல்வியடைந்தது',
        success: 'வெற்றிகரமாக உள்நுழைந்தீர்கள்!',
        invalidCredentials:
          'தவறான அனுமதி விவரங்கள். தயவு செய்து பயனர் பெயர் மற்றும் கடவுச்சொல்லை சரிபார்க்கவும்.',
        serviceUnavailable:
          'உள்நுழைவு சேவை தற்காலிகமாக கிடைக்கவில்லை. தயவு செய்து பின்னர் மீண்டும் முயற்சிக்கவும்.',
        gatewayError:
          'உள்நுழைவு சேவையகம் தற்போது அணுக முடியவில்லை. தயவு செய்து பின்னர் முயற்சிக்கவும்.',
        serverError:
          'உள்நுழைவு போது சேவையகப் பிழை ஏற்பட்டுள்ளது. சில நிமிடங்களில் மீண்டும் முயற்சிக்கவும்.',
        networkError:
          'உள்நுழைவு சேவையகத்தை அணுக முடியவில்லை. உங்கள் இணைய இணைப்பை சரிபார்த்து மீண்டும் முயற்சிக்கவும்.',
        usernameLabel: 'பயனர் பெயர் அல்லது மின்னஞ்சல்',
        usernamePlaceholder: 'உங்கள் பயனர் பெயர் அல்லது மின்னஞ்சலை உள்ளிடவும்',
        usernameRequired: 'பயனர் பெயர் அல்லது மின்னஞ்சல் தேவை',
        usernameMinLength: 'குறைந்தது 3 எழுத்துக்கள் தேவை',
        usernameInvalid: 'சரியான மின்னஞ்சல் அல்லது பயனர் பெயரை உள்ளிடவும்',
        passwordLabel: 'கடவுச்சொல்',
        passwordPlaceholder: 'உங்கள் கடவுச்சொல்லை உள்ளிடவும்',
        passwordRequired: 'கடவுச்சொல் தேவை',
        passwordMinLength:
          'கடவுச்சொல் குறைந்தது 6 எழுத்துக்களாக இருக்க வேண்டும்',
        usernameHelper:
          'Keycloak படிவத்தில் பயனர் பெயர் முன்கூட்டியே நிரப்பப்படும்.',
        remark: 'கணக்கு இல்லையா? நிர்வாகியைத் தொடர்பு கொள்ளவும்.',
        cancel: 'ரத்து செய்',
        login: 'உள்நுழை',
        loggingIn: 'உள்நுழைகிறது...',
      },

      // Categories
      categories: {
        all: 'அனைத்து வகைகள்',
        love: 'காதல்',
        nature: 'இயற்கை',
        philosophy: 'தத்துவம்',
        social: 'சமூகம்',
        spiritual: 'ஆன்மீகம்',
        modern: 'நவீனம்',
        classical: 'பாரம்பரியம்',
      },

      explore: {
        title: 'கவிதைகளை ஆராயுங்கள் – Kavithai.de',
        description: 'எங்கள் அனைத்து தமிழ் கவிதைத் தொகுப்பையும் உலாவவும்.',
        heading: 'கவிதைகளை ஆராயுங்கள்',
        subheading:
          'எங்கள் தேர்ந்தெடுக்கப்பட்ட தமிழ் கவிதைத் தொகுப்பில் மூழ்குங்கள்.',
        searchPlaceholder:
          'தலைப்பு, ஆசிரியர் அல்லது உள்ளடக்கத்தின் மூலம் தேடவும்',
        sort: {
          recent: 'சமீபத்தியது',
          title: 'தலைப்பு',
          author: 'ஆசிரியர்',
        },
      },

      // Admin specific
      basicInfo: 'அடிப்படை தகவல்',
      categorization: 'வகைப்படுத்துதல்',
      publication: 'வெளியீடு',
      existingPoems: 'இருக்கும் கவிதைகள்',
      noCategory: 'வகை இல்லை',
      addTags: 'குறிச்சொற்களைச் சேர்க்கவும்',
      update: 'புதுப்பிக்க',
      required: 'தேவை',
      adminDashboard: 'நிர்வாக கட்டுப்பாட்டு பலகை',
      createNewPoem: 'புதிய கவிதை உருவாக்கு',
      quickEdit: 'விரைவு திருத்தம்',
      step: 'படி',
      of: 'இல்',
      saving: 'சேமிக்கிறது',
      finish: 'முடிக்க',
      review: 'மறுஆய்வு',
      description: 'விளக்கம்',
      mood: 'மனநிலை',
      theme: 'கருப்பொருள்',
      publishImmediately: 'உடனடியாக வெளியிடு',
      saveAsDraft: 'வரைவாக சேமி',
      createPoem: 'கவிதை உருவாக்கு',
      createPoemDescription:
        'எங்கள் பல-படி படிவத்துடன் அழகான கவிதை உருவாக்கவும்',
      editPoemDescription:
        'எங்கள் பல-படி படிவத்துடன் உங்கள் கவிதையை திருத்தவும்',
      updatePoem: 'கவிதையை புதுப்பிக்க',
      poemUpdated: 'கவிதை வெற்றிகரமாக புதுப்பிக்கப்பட்டது',
      moods: {
        happy: 'மகிழ்ச்சி',
        sad: 'வருத்தம்',
        romantic: 'காதல்',
        philosophical: 'தத்துவ',
        nostalgic: 'பழைய நினைவு',
        hopeful: 'நம்பிக்கை',
        melancholic: 'வருத்தம்',
        energetic: 'ஆற்றல்',
        peaceful: 'அமைதி',
        mysterious: 'மர்மம்',
      },
      themes: {
        general: 'பொது',
        family: 'குடும்பம்',
        friendship: 'நட்பு',
        nature: 'இயற்கை',
        love: 'காதல்',
        death: 'மரணம்',
        time: 'நேரம்',
        dreams: 'கனவுகள்',
        reality: 'உண்மை',
        spirituality: 'ஆன்மீகம்',
      },
    },
  },

  de: {
    translation: {
      // App & Navigation
      appTitle: 'Gedichte',
      appSubtitle: 'Moderne Plattform für tamilische Gedichte',
      nav: {
        home: 'Start',
        poems: 'Gedichte',
        admin: 'Admin',
        myArea: 'Mein Bereich',
        login: 'Login',
        logout: 'Logout',
        register: 'Registrieren',
        forgotPassword: 'Passwort vergessen',
        about: 'Über uns',
        contact: 'Kontakt',
        openMenu: 'Navigationsmenü öffnen',
        closeMenu: 'Navigationsmenü schließen',
        languageMenuLabel: 'Sprache ändern',
        switchToDarkMode: 'Zum Dunkelmodus wechseln',
        switchToLightMode: 'Zum Hellmodus wechseln',
      },

      // Admin Panel
      adminPanel: {
        title: 'Admin-Panel',
        description: 'Administrator-Funktionen',
        subtitle: 'Spezielle Administrator-Funktionen',
        placeholder: 'Dieser Bereich ist noch in Entwicklung. Hier werden später spezielle Admin-Funktionen verfügbar sein.',
        comingSoon: 'Funktionen kommen bald...',
        pendingRegistrations: 'Ausstehende Registrierungen',
        noPendingUsers: 'Keine ausstehenden Registrierungen',
        username: 'Benutzername',
        email: 'E-Mail',
        name: 'Name',
        registered: 'Registriert am',
        actions: 'Aktionen',
        approve: 'Genehmigen',
        reject: 'Ablehnen',
        rejectConfirmTitle: 'Registrierung ablehnen?',
        rejectConfirmText: 'Möchten Sie diese Registrierung wirklich ablehnen? Der Benutzer wird gelöscht und kann sich nicht anmelden.',
        cancel: 'Abbrechen',
        confirmReject: 'Ablehnen',
        approveError: 'Fehler beim Genehmigen des Benutzers',
        rejectError: 'Fehler beim Ablehnen des Benutzers',
        refresh: 'Aktualisieren',
      },

      // Admin
      admin: {
        dashboard: 'Admin-Dashboard',
        welcome: 'Willkommen zurück',
        totalPoems: 'Gesamte Gedichte',
        publishedPoems: 'Veröffentlicht',
        draftPoems: 'Entwürfe',
        views: 'Aufrufe',
        quickActions: 'Schnellaktionen',
        createPoem: 'Neues Gedicht erstellen',
        viewSite: 'Website anzeigen',
        recentPoems: 'Neueste Gedichte',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        deleteConfirmation: 'Möchten Sie dieses Gedicht wirklich löschen?',
      },

      // Manage Poems
      managePoems: {
        managePoems: 'Gedichte verwalten',
        createNew: 'Neues Gedicht erstellen',
        totalPoems: 'Gesamte Gedichte',
        published: 'Veröffentlicht',
        drafts: 'Entwürfe',
        searchPlaceholder: 'Gedichte durchsuchen...',
        filter: 'Filter',
        all: 'Alle',
        title: 'Titel',
        author: 'Autor',
        status: 'Status',
        views: 'Aufrufe',
        tags: 'Tags',
        updated: 'Aktualisiert',
        actions: 'Aktionen',
        view: 'Anzeigen',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        noPoemsFound: 'Keine Gedichte gefunden',
        tryDifferentSearch:
          'Versuchen Sie, Ihre Such- oder Filterkriterien anzupassen',
        createFirstPoem: 'Erstellen Sie Ihr erstes Gedicht, um zu beginnen',
        deletePoem: 'Gedicht löschen',
        deleteWarning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
        deleteConfirm: 'Sind Sie sicher, dass Sie löschen möchten',
        cancel: 'Abbrechen',
      },

      // Logout
      logout: {
        successTitle: 'Erfolgreich abgemeldet',
        successMessage:
          'Sie wurden erfolgreich von Ihrem Konto abgemeldet. Alle Ihre Sitzungsdaten wurden sicher gelöscht.',
        securityNote:
          'Aus Sicherheitsgründen empfehlen wir Ihnen, Ihren Browser zu schließen, wenn Sie an einem öffentlichen Computer arbeiten.',
        backToHome: 'Zur Startseite',
        loginAgain: 'Erneut anmelden',
        thankYou: 'Vielen Dank für die Nutzung von Kavithai.de',
      },

      // 404 Not Found
      notFound: {
        title: 'Seite nicht gefunden',
        message:
          'Die Seite, die Sie suchen, existiert nicht oder wurde verschoben. Überprüfen Sie die URL oder kehren Sie zur Startseite zurück.',
        suggestion:
          'Möglicherweise haben Sie sich in der URL vertippt oder die Seite wurde umbenannt.',
        backToHome: 'Zur Startseite',
        goBack: 'Zurück',
        browsePoems: 'Gedichte durchsuchen',
        contact: 'Kontakt',
        helpText:
          'Benötigen Sie Hilfe? Kontaktieren Sie uns über die Kontaktseite.',
      },

      // Poems (legacy)
      addPoem: 'Neues Gedicht',
      editPoem: 'Gedicht bearbeiten',
      deletePoem: 'Gedicht löschen',
      poemTitle: 'Gedichttitel',
      poemAuthor: 'Dichter',
      poemDate: 'Datum',
      poemContent: 'Gedichtinhalt',
      poemLanguage: 'Sprache',
      poemCategory: 'Kategorie',
      poemTags: 'Tags',

      // Form Fields
      title: 'Titel',
      author: 'Autor',
      language: 'Sprache',
      content: 'Inhalt',
      category: 'Kategorie',
      tags: 'Tags',
      published: 'Veröffentlicht',
      draft: 'Entwurf',

      // Actions
      save: 'Speichern',
      cancel: 'Abbrechen',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      publish: 'Veröffentlichen',
      unpublish: 'Veröffentlichung zurückziehen',
      search: 'Suchen',
      filter: 'Filter',
      sort: 'Sortieren',
      copy: 'Kopieren',
      share: 'Teilen',
      like: 'Gefällt mir',
      bookmark: 'Merken',

      // Authentication
      email: 'E-Mail',
      password: 'Passwort',
      signIn: 'Anmelden',
      signOut: 'Abmelden',
      loginSuccess: 'Erfolgreich angemeldet',
      loginError: 'Anmeldung fehlgeschlagen',

      // UI Elements
      loading: 'Lädt...',
      error: 'Fehler',
      technicalError:
        'Technischer Fehler. Bitte versuchen Sie es später erneut.',
      success: 'Erfolg',
      warning: 'Warnung',
      info: 'Information',
      close: 'Schließen',
      retry: 'Erneut versuchen',
      back: 'Zurück',
      by: 'von',
      next: 'Weiter',
      previous: 'Vorherige',
      readMore: 'Mehr lesen',
      showLess: 'Weniger anzeigen',

      // Toast Messages
      poemNotFound: 'Gedicht nicht gefunden',
      poem: {
        notFoundTitle: 'Gedicht nicht gefunden',
        notFoundMessage: 'Dieses Gedicht wurde gelöscht oder ist nicht mehr verfügbar.',
        errorTitle: 'Technischer Fehler',
        errorMessage: 'Es ist ein technischer Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
        views: 'Aufrufe',
      },

      // Contact Form
      contact: {
        title: 'Kontakt',
        subtitle:
          'Haben Sie eine Frage oder einen Vorschlag? Wir freuen uns von Ihnen zu hören. Senden Sie uns eine Nachricht und wir antworten so schnell wie möglich.',
        description:
          'Kontaktieren Sie Kavithai.de. Wir freuen uns von Ihnen zu hören!',
        form: {
          title: 'Nachricht senden',
          name: 'Name',
          namePlaceholder: 'Ihr vollständiger Name',
          nameRequired: 'Name ist erforderlich',
          nameMinLength: 'Name muss mindestens 2 Zeichen lang sein',
          email: 'E-Mail',
          emailPlaceholder: 'ihre.email@beispiel.de',
          emailRequired: 'E-Mail ist erforderlich',
          emailInvalid: 'Ungültige E-Mail-Adresse',
          subject: 'Betreff',
          subjectPlaceholder: 'Worum geht es?',
          subjectRequired: 'Betreff ist erforderlich',
          subjectMinLength: 'Betreff muss mindestens 5 Zeichen lang sein',
          message: 'Nachricht',
          messagePlaceholder: 'Ihre Nachricht hier...',
          messageRequired: 'Nachricht ist erforderlich',
          messageMinLength: 'Nachricht muss mindestens 10 Zeichen lang sein',
          send: 'Nachricht senden',
          sending: 'Wird gesendet...',
          success:
            'Vielen Dank für Ihre Nachricht! Wir melden uns bald bei Ihnen.',
          error: 'Senden fehlgeschlagen. Bitte versuchen Sie es erneut.',
        },
        info: {
          title: 'Kontaktinformationen',
          email: 'E-Mail',
          phone: 'Telefon',
          phoneAvailable: 'Auf Anfrage verfügbar',
          location: 'Standort',
        },
        help: {
          title: 'Brauchen Sie Hilfe?',
          description:
            'Schauen Sie sich unsere FAQ an oder durchstöbern Sie unsere Gedichtesammlung.',
          exploreButton: 'Gedichte erkunden',
        },
      },

      // Accessibility
      fontSize: 'Schriftgröße',
      increaseFont: 'Schriftgröße erhöhen',
      decreaseFont: 'Schriftgröße verringern',
      highContrast: 'Hoher Kontrast',
      skipToContent: 'Zum Inhalt springen',
      accessibilityMenuOpen: 'Barrierefreiheitsoptionen öffnen',
      accessibilityMenuClose: 'Barrierefreiheitsoptionen schließen',
      fontSizeSliderLabel: 'Basis-Schriftgröße anpassen',
      highContrastToggleLabel: 'Hohen Kontrast umschalten',

      // Messages
      noPoemsFound: 'Keine Gedichte gefunden',
      confirmDelete: 'Möchten Sie dieses Gedicht wirklich löschen?',
      poemSaved: 'Gedicht erfolgreich gespeichert',
      poemDeleted: 'Gedicht gelöscht',
      adminLoginDescription:
        'Melde dich mit deinem Admin-Konto an, um Gedichte zu verwalten.',
      loginForm: {
        headline: 'Anmelden',
        intro:
          'Du wirst im nächsten Schritt zur sicheren Keycloak-Anmeldung weitergeleitet.',
        error: 'Anmeldung fehlgeschlagen',
        success: 'Erfolgreich angemeldet!',
        invalidCredentials:
          'Ungültige Zugangsdaten. Bitte überprüfe Benutzername und Passwort.',
        serviceUnavailable:
          'Der Anmeldeservice ist derzeit nicht verfügbar. Bitte versuche es später erneut.',
        gatewayError:
          'Der Anmeldeserver ist vorübergehend nicht erreichbar. Bitte versuche es später erneut.',
        serverError:
          'Bei der Anmeldung ist ein Serverfehler aufgetreten. Bitte versuche es später erneut.',
        networkError:
          'Keine Verbindung zum Anmeldeserver. Bitte überprüfe deine Internetverbindung und versuche es erneut.',
        usernameLabel: 'Benutzername oder E-Mail',
        usernamePlaceholder: 'Benutzername oder E-Mail eingeben',
        usernameRequired: 'Benutzername oder E-Mail ist erforderlich',
        usernameMinLength: 'Mindestens 3 Zeichen erforderlich',
        usernameInvalid:
          'Bitte geben Sie eine gültige E-Mail oder einen Benutzernamen ein',
        passwordLabel: 'Passwort',
        passwordPlaceholder: 'Passwort eingeben',
        passwordRequired: 'Passwort ist erforderlich',
        passwordMinLength: 'Passwort muss mindestens 6 Zeichen haben',
        usernameHelper:
          'Der Nutzername wird in der Keycloak-Maske bereits vorausgefüllt.',
        remark: 'Kein Konto vorhanden? Kontaktieren Sie den Administrator.',
        cancel: 'Abbrechen',
        login: 'Anmelden',
        loggingIn: 'Wird angemeldet...',
      },

      // Categories
      categories: {
        all: 'Alle Kategorien',
        love: 'Liebe',
        nature: 'Natur',
        philosophy: 'Philosophie',
        social: 'Gesellschaft',
        spiritual: 'Spiritualität',
        modern: 'Modern',
        classical: 'Klassisch',
      },

      explore: {
        title: 'Gedichte entdecken – Kavithai.de',
        description:
          'Stöbern Sie in der vollständigen Sammlung tamilischer Gedichte.',
        heading: 'Gedichte entdecken',
        subheading:
          'Tauchen Sie in unsere kuratierte Sammlung klassischer und moderner tamilischer Poesie ein.',
        searchPlaceholder: 'Gedichte nach Titel, Autor oder Text durchsuchen',
        sort: {
          recent: 'Neueste',
          title: 'Titel',
          author: 'Autor',
        },
      },

      // Admin specific
      basicInfo: 'Grundinformationen',
      categorization: 'Kategorisierung',
      publication: 'Veröffentlichung',
      existingPoems: 'Vorhandene Gedichte',
      noCategory: 'Keine Kategorie',
      addTags: 'Tags hinzufügen',
      update: 'Aktualisieren',
      required: 'Erforderlich',
      adminDashboard: 'Admin Dashboard',
      createNewPoem: 'Neues Gedicht erstellen',
      quickEdit: 'Schnell bearbeiten',
      step: 'Schritt',
      of: 'von',
      saving: 'Speichern',
      finish: 'Beenden',
      review: 'Überprüfung',
      description: 'Beschreibung',
      mood: 'Stimmung',
      theme: 'Thema',
      publishImmediately: 'Sofort veröffentlichen',
      saveAsDraft: 'Als Entwurf speichern',
      createPoem: 'Gedicht erstellen',
      createPoemDescription:
        'Erstellen Sie ein schönes Gedicht mit unserem mehrstufigen Formular',
      editPoemDescription:
        'Bearbeiten Sie Ihr Gedicht mit unserem mehrstufigen Formular',
      updatePoem: 'Gedicht aktualisieren',
      poemUpdated: 'Gedicht erfolgreich aktualisiert',
      moods: {
        happy: 'Fröhlich',
        sad: 'Traurig',
        romantic: 'Romantisch',
        philosophical: 'Philosophisch',
        nostalgic: 'Nostalgisch',
        hopeful: 'Hoffnungsvoll',
        melancholic: 'Melancholisch',
        energetic: 'Energisch',
        peaceful: 'Friedlich',
        mysterious: 'Mysteriös',
      },
      themes: {
        general: 'Allgemein',
        family: 'Familie',
        friendship: 'Freundschaft',
        nature: 'Natur',
        love: 'Liebe',
        death: 'Tod',
        time: 'Zeit',
        dreams: 'Träume',
        reality: 'Realität',
        spirituality: 'Spiritualität',
      },
    },
  },

  en: {
    translation: {
      // App & Navigation
      appTitle: 'Poems',
      appSubtitle: 'Modern platform for Tamil poetry',
      nav: {
        home: 'Home',
        poems: 'Poems',
        admin: 'Admin',
        myArea: 'My Area',
        login: 'Login',
        logout: 'Logout',
        register: 'Register',
        forgotPassword: 'Forgot Password',
        about: 'About',
        contact: 'Contact',
        openMenu: 'Open navigation menu',
        closeMenu: 'Close navigation menu',
        languageMenuLabel: 'Change language',
        switchToDarkMode: 'Switch to dark mode',
        switchToLightMode: 'Switch to light mode',
      },

      // Poems (legacy)
      addPoem: 'Add Poem',
      editPoem: 'Edit Poem',
      deletePoem: 'Delete Poem',
      poemTitle: 'Poem Title',
      poemAuthor: 'Poet',
      poemDate: 'Date',
      poemContent: 'Poem Content',
      poemLanguage: 'Language',
      poemCategory: 'Category',
      poemTags: 'Tags',

      // Form Fields
      title: 'Title',
      author: 'Author',
      language: 'Language',
      content: 'Content',
      category: 'Category',
      tags: 'Tags',
      published: 'Published',
      draft: 'Draft',

      // Actions
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      publish: 'Publish',
      unpublish: 'Unpublish',
      search: 'Search',
      filter: 'Filter',
      sort: 'Sort',
      copy: 'Copy',
      share: 'Share',
      like: 'Like',
      bookmark: 'Bookmark',

      // Authentication
      email: 'Email',
      password: 'Password',
      signIn: 'Sign in',
      signOut: 'Sign out',
      loginSuccess: 'Successfully signed in',
      loginError: 'Sign in failed',

      // UI Elements
      loading: 'Loading...',
      error: 'Error',
      technicalError: 'Technical error. Please try again later.',
      success: 'Success',
      warning: 'Warning',
      info: 'Information',
      close: 'Close',
      retry: 'Retry',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      readMore: 'Read more',
      showLess: 'Show less',
      by: 'by',

      // Toast Messages
      poemNotFound: 'Poem not found',
      poem: {
        notFoundTitle: 'Poem not found',
        notFoundMessage: 'This poem was deleted or is no longer available.',
        errorTitle: 'Technical error',
        errorMessage: 'A technical error occurred. Please try again later.',
        views: 'Views',
      },

      // Contact Form
      contact: {
        title: 'Contact Us',
        subtitle:
          "Have a question or suggestion? We'd love to hear from you. Send us a message and we'll respond as soon as possible.",
        description: 'Get in touch with Kavithai.de. We love to hear from you!',
        form: {
          title: 'Send us a Message',
          name: 'Name',
          namePlaceholder: 'Your full name',
          nameRequired: 'Name is required',
          nameMinLength: 'Name must be at least 2 characters',
          email: 'Email',
          emailPlaceholder: 'your.email@example.com',
          emailRequired: 'Email is required',
          emailInvalid: 'Invalid email address',
          subject: 'Subject',
          subjectPlaceholder: 'What is this about?',
          subjectRequired: 'Subject is required',
          subjectMinLength: 'Subject must be at least 5 characters',
          message: 'Message',
          messagePlaceholder: 'Your message here...',
          messageRequired: 'Message is required',
          messageMinLength: 'Message must be at least 10 characters',
          send: 'Send Message',
          sending: 'Sending...',
          success: "Thank you for your message! We'll get back to you soon.",
          error: 'Failed to send message. Please try again.',
        },
        info: {
          title: 'Contact Information',
          email: 'Email',
          phone: 'Phone',
          phoneAvailable: 'Available upon request',
          location: 'Location',
        },
        help: {
          title: 'Need Help?',
          description:
            'Check out our FAQ or browse through our poetry collection.',
          exploreButton: 'Explore Poems',
        },
      },

      // Accessibility
      fontSize: 'Font Size',
      increaseFont: 'Increase font size',
      decreaseFont: 'Decrease font size',
      highContrast: 'High contrast',
      skipToContent: 'Skip to content',
      accessibilityMenuOpen: 'Open accessibility controls',
      accessibilityMenuClose: 'Close accessibility controls',
      fontSizeSliderLabel: 'Adjust base font size',
      highContrastToggleLabel: 'Toggle high contrast mode',

      // Messages
      noPoemsFound: 'No poems found',
      confirmDelete: 'Are you sure you want to delete this poem?',
      poemSaved: 'Poem saved successfully',
      poemDeleted: 'Poem deleted',
      adminLoginDescription: 'Sign in with your admin account to manage poems.',
      forgotPassword: {
        title: 'Forgot Password',
        description: 'Enter your email address or username to receive a link to reset your password.',
        emailLabel: 'Email Address',
        usernameLabel: 'Username',
        or: 'or',
        sendResetLink: 'Send Reset Link',
        sending: 'Sending...',
        successMessage: 'If an account with this email address or username exists, a password reset link has been sent. Please check your email inbox.',
        backToHome: 'Back to Home',
        error: 'Failed to send password reset link. Please try again.',
      },
      loginForm: {
        headline: 'Sign in',
        intro:
          'You will be redirected to the secure Keycloak login in the next step.',
        error: 'Sign in failed',
        success: 'Successfully signed in!',
        invalidCredentials:
          'Invalid credentials. Please verify your username and password.',
        serviceUnavailable:
          'The login service is temporarily unavailable. Please try again later.',
        gatewayError:
          'The login server is temporarily unreachable. Please try again later.',
        serverError:
          'A server error occurred during sign in. Please try again later.',
        networkError:
          'Unable to reach the login server. Check your internet connection and try again.',
        usernameLabel: 'Username or email',
        usernamePlaceholder: 'Enter your username or email',
        usernameRequired: 'Username or email is required',
        usernameMinLength: 'At least 3 characters required',
        usernameInvalid: 'Please enter a valid email or username',
        passwordLabel: 'Password',
        passwordPlaceholder: 'Enter your password',
        passwordRequired: 'Password is required',
        passwordMinLength: 'Password must be at least 6 characters',
        usernameHelper:
          'The username will already be pre-filled in the Keycloak form.',
        remark: "Don't have an account? Contact the administrator.",
        cancel: 'Cancel',
        login: 'Sign in',
        loggingIn: 'Signing in...',
      },

      // Categories
      categories: {
        all: 'All categories',
        love: 'Love',
        nature: 'Nature',
        philosophy: 'Philosophy',
        social: 'Social',
        spiritual: 'Spiritual',
        modern: 'Modern',
        classical: 'Classical',
      },

      explore: {
        title: 'Explore Poems – Kavithai.de',
        description:
          'Browse the complete collection of Tamil poems on Kavithai.de.',
        heading: 'Explore Poems',
        subheading:
          'Discover our curated collection of classic and contemporary Tamil poetry.',
        searchPlaceholder: 'Search poems by title, author, or text',
        sort: {
          recent: 'Newest',
          title: 'Title',
          author: 'Author',
        },
      },

      // Admin specific
      basicInfo: 'Basic Information',
      categorization: 'Categorization',
      publication: 'Publication',
      existingPoems: 'Existing Poems',
      noCategory: 'No Category',
      addTags: 'Add tags',
      update: 'Update',
      required: 'Required',
      adminDashboard: 'Admin Dashboard',
      createNewPoem: 'Create New Poem',
      quickEdit: 'Quick Edit',
      step: 'Step',
      of: 'of',
      saving: 'Saving',
      finish: 'Finish',
      review: 'Review',
      description: 'Description',
      mood: 'Mood',
      theme: 'Theme',
      publishImmediately: 'Publish immediately',
      saveAsDraft: 'Save as draft',
      createPoem: 'Create Poem',
      createPoemDescription: 'Create a beautiful poem with our multi-step form',
      editPoemDescription: 'Edit your poem with our multi-step form',
      updatePoem: 'Update Poem',
      poemUpdated: 'Poem updated successfully',
      moods: {
        happy: 'Happy',
        sad: 'Sad',
        romantic: 'Romantic',
        philosophical: 'Philosophical',
        nostalgic: 'Nostalgic',
        hopeful: 'Hopeful',
        melancholic: 'Melancholic',
        energetic: 'Energetic',
        peaceful: 'Peaceful',
        mysterious: 'Mysterious',
      },
      themes: {
        general: 'General',
        family: 'Family',
        friendship: 'Friendship',
        nature: 'Nature',
        love: 'Love',
        death: 'Death',
        time: 'Time',
        dreams: 'Dreams',
        reality: 'Reality',
        spirituality: 'Spirituality',
      },

      // Admin Panel
      adminPanel: {
        title: 'Admin Panel',
        description: 'Administrator Functions',
        subtitle: 'Special Administrator Functions',
        placeholder: 'This area is still under development. Special admin functions will be available here later.',
        comingSoon: 'Features coming soon...',
        pendingRegistrations: 'Pending Registrations',
        noPendingUsers: 'No pending registrations',
        username: 'Username',
        email: 'Email',
        name: 'Name',
        registered: 'Registered on',
        actions: 'Actions',
        approve: 'Approve',
        reject: 'Reject',
        rejectConfirmTitle: 'Reject Registration?',
        rejectConfirmText: 'Do you really want to reject this registration? The user will be deleted and cannot log in.',
        cancel: 'Cancel',
        confirmReject: 'Reject',
        approveError: 'Failed to approve user',
        rejectError: 'Failed to reject user',
        refresh: 'Refresh',
      },

      // Admin
      admin: {
        dashboard: 'Admin Dashboard',
        welcome: 'Welcome back',
        totalPoems: 'Total Poems',
        publishedPoems: 'Published',
        draftPoems: 'Drafts',
        views: 'Total Views',
        quickActions: 'Quick Actions',
        createPoem: 'Create New Poem',
        viewSite: 'View Site',
        recentPoems: 'Recent Poems',
        edit: 'Edit',
        delete: 'Delete',
        deleteConfirmation: 'Are you sure you want to delete this poem?',
      },

      // Manage Poems
      managePoems: {
        managePoems: 'Manage Poems',
        createNew: 'Create New Poem',
        totalPoems: 'Total Poems',
        published: 'Published',
        drafts: 'Drafts',
        searchPlaceholder: 'Search poems...',
        filter: 'Filter',
        all: 'All',
        title: 'Title',
        author: 'Author',
        status: 'Status',
        views: 'Views',
        tags: 'Tags',
        updated: 'Updated',
        actions: 'Actions',
        view: 'View',
        edit: 'Edit',
        delete: 'Delete',
        noPoemsFound: 'No poems found',
        tryDifferentSearch: 'Try adjusting your search or filter criteria',
        createFirstPoem: 'Create your first poem to get started',
        deletePoem: 'Delete Poem',
        deleteWarning: 'This action cannot be undone.',
        deleteConfirm: 'Are you sure you want to delete',
        cancel: 'Cancel',
      },

      // Logout
      logout: {
        successTitle: 'Successfully Logged Out',
        successMessage:
          'You have been successfully logged out of your account. All your session data has been securely deleted.',
        securityNote:
          'For security reasons, we recommend closing your browser if you are working on a public computer.',
        backToHome: 'Back to Home',
        loginAgain: 'Login Again',
        thankYou: 'Thank you for using Kavithai.de',
      },

      // 404 Not Found
      notFound: {
        title: 'Page Not Found',
        message:
          'The page you are looking for does not exist or has been moved. Check the URL or return to the home page.',
        suggestion:
          'You may have mistyped the URL or the page has been renamed.',
        backToHome: 'Back to Home',
        goBack: 'Go Back',
        browsePoems: 'Browse Poems',
        contact: 'Contact',
        helpText: 'Need help? Contact us through the contact page.',
      },
    },
  },
};

// Function to get saved language preference
const getSavedLanguage = (): string | null => {
  try {
    return localStorage.getItem('kavithai-language');
  } catch (error) {
    console.warn(
      'Could not access localStorage for language preference:',
      error
    );
    return null;
  }
};

// Function to save language preference
export const saveLanguagePreference = (language: string): void => {
  try {
    localStorage.setItem('kavithai-language', language);
    console.log('💾 Language preference saved:', language);
  } catch (error) {
    console.warn('Could not save language preference to localStorage:', error);
  }
};

// Function to detect browser language
const detectBrowserLanguage = (): string => {
  // First, check if user has a saved language preference
  const savedLanguage = getSavedLanguage();
  if (savedLanguage && ['ta', 'de', 'en'].includes(savedLanguage)) {
    console.log('💾 Using saved language preference:', savedLanguage);
    return savedLanguage;
  }

  // Get browser language with fallbacks
  const browserLang =
    navigator.language ||
    (navigator as any).userLanguage ||
    (navigator as any).browserLanguage ||
    'ta'; // Ultimate fallback

  console.log('🌍 Browser language detected:', browserLang);

  const langCode = browserLang.split('-')[0].toLowerCase(); // Get language code (e.g., 'en' from 'en-US')

  // Check if the detected language is supported
  const supportedLanguages = ['ta', 'de', 'en'];
  if (supportedLanguages.includes(langCode)) {
    console.log('✅ Using detected language:', langCode);
    return langCode;
  }

  // Check for Tamil specifically (ta-IN, ta-LK, etc.)
  if (browserLang.toLowerCase().startsWith('ta')) {
    console.log('✅ Using Tamil (detected from full code)');
    return 'ta';
  }

  // Check for German specifically (de-DE, de-AT, etc.)
  if (browserLang.toLowerCase().startsWith('de')) {
    console.log('✅ Using German (detected from full code)');
    return 'de';
  }

  // Check for English specifically (en-US, en-GB, etc.)
  if (browserLang.toLowerCase().startsWith('en')) {
    console.log('✅ Using English (detected from full code)');
    return 'en';
  }

  // Additional language mappings for common cases
  const languageMappings: { [key: string]: string } = {
    hi: 'ta', // Hindi -> Tamil (Indian languages)
    te: 'ta', // Telugu -> Tamil
    kn: 'ta', // Kannada -> Tamil
    ml: 'ta', // Malayalam -> Tamil
    bn: 'ta', // Bengali -> Tamil
    gu: 'ta', // Gujarati -> Tamil
    pa: 'ta', // Punjabi -> Tamil
    or: 'ta', // Odia -> Tamil
    as: 'ta', // Assamese -> Tamil
    ne: 'ta', // Nepali -> Tamil
    si: 'ta', // Sinhala -> Tamil
    fr: 'en', // French -> English
    es: 'en', // Spanish -> English
    it: 'en', // Italian -> English
    pt: 'en', // Portuguese -> English
    ru: 'en', // Russian -> English
    ja: 'en', // Japanese -> English
    ko: 'en', // Korean -> English
    zh: 'en', // Chinese -> English
    ar: 'en', // Arabic -> English
  };

  if (languageMappings[langCode]) {
    const mappedLang = languageMappings[langCode];
    console.log(`🔄 Mapped ${langCode} -> ${mappedLang}`);
    return mappedLang;
  }

  // Default fallback to Tamil (primary language of the site)
  console.log('🔄 Using default language: Tamil');
  return 'ta';
};

i18n.use(initReactI18next).init({
  resources,
  lng: detectBrowserLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
